<template>
  <a v-if="href" :href="href" target="_blank" :class="['IconButton', {'IconButton--rounded': rounded}]">
    <slot></slot>
  </a>
  <a v-else :class="['IconButton', {'IconButton--rounded': rounded}]">
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    href: String,
    rounded: Boolean,
  }
}
</script>

<style scoped lang="stylus">
.IconButton
  display block
  width 20px
  height @width
  margin 15px 0
  cursor pointer
  opacity 0.8
  transition opacity 200ms ease-out
  &:hover
    opacity 1
  &--rounded
    border-radius 50px
    border 2px solid white
    padding 10px
    width 40px
    height 40px
    opacity 1
    transition background 200ms ease-out
    &:hover
      background rgba(255, 255, 255, 0.4)
  >>> img
  >>> svg
    width 100%
    height 100%
    display block
    object-fit contain
    
</style>